export default "__VITE_ASSET__44c5695c__"